import { render } from "./KitchenSettingsTab.vue?vue&type=template&id=10acb22e"
import script from "./KitchenSettingsTab.vue?vue&type=script&lang=js"
export * from "./KitchenSettingsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__